var map = {
	"./DAO.png": "qeua",
	"./ai.png": "88Z3",
	"./arb.png": "/Xbt",
	"./arbitrum.png": "ULMx",
	"./ark.png": "xMNe",
	"./ava.png": "viMP",
	"./avalanche.png": "DS/N",
	"./avatar-default.png": "I0uQ",
	"./bitcoin-ordinals.png": "u7mw",
	"./charity.png": "MLtm",
	"./climate.png": "yR/B",
	"./cookie.png": "9nUf",
	"./cover-picture-icon.png": "cR2b",
	"./empty-state-company@2x.png": "4LEn",
	"./empty-state-eyes@2x.png": "AO4T",
	"./empty-state-icon@2x.png": "nIN5",
	"./empty-state-messages@2x.png": "u399",
	"./error-monkey.png": "SVzs",
	"./ethereum.png": "Kof2",
	"./flag-ch@2x.png": "ybea",
	"./flag-ch@3x.png": "Bgb/",
	"./flag-gb@2x.png": "9ZAr",
	"./flag-gb@3x.png": "HmwI",
	"./google-logo.png": "xY12",
	"./green-house-active.png": "rQGE",
	"./green-house.png": "341O",
	"./header-default.png": "zPv5",
	"./hiro-wallet-blue.png": "9x4I",
	"./hiro-wallet.png": "LHDx",
	"./job-header-default.png": "hRxm",
	"./lever-active.png": "g3Sy",
	"./lever.png": "coqS",
	"./light.png": "dPD+",
	"./lightning.png": "Xjax",
	"./logo.png": "7Otq",
	"./lynx.png": "ZHjp",
	"./mailbox.png": "vemy",
	"./mobile.png": "dft9",
	"./mundo-crypto-attach.png": "+7Qq",
	"./mundo-crypto-unattach.png": "QY0/",
	"./network-states.png": "nVYR",
	"./nostr.png": "Q0hH",
	"./op.png": "G/3P",
	"./ordinals.png": "Idus",
	"./polkadot.png": "imux",
	"./polygon.png": "RqSw",
	"./rgb.png": "K9AO",
	"./rootstock.png": "2G0k",
	"./scatter-bg-pattern-light.png": "SwJ0",
	"./scatter-bg-pattern.png": "T3Tp",
	"./scatter.png": "TvIB",
	"./scatter20x20.png": "8hSe",
	"./scatter@2x.png": "e4p+",
	"./scatter@3x.png": "rqto",
	"./solana.png": "Fn9l",
	"./sparkels.png": "XOp4",
	"./stacks.png": "qqYK",
	"./tool-tip.png": "xKEk",
	"./vote-against.png": "kXaE",
	"./vote-for.png": "JFdU",
	"./web2.png": "b9Z9",
	"./zk.png": "dpCv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BEjn";


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive \.png$
// module id = BEjn
// module chunks = 7